module.exports = __webpack_public_path__ + "images/profile-manager.png?4f08f";